import { Modal } from "react-bootstrap";
import BaseCom from "../../components/BaseCom";
import { SidebarGlobal } from "../../components/Bridge/Sidebar";
import Card from "../../components/Card";
import FormInputV2 from "../../components/FormInputV2";
import L from "../../components/Lang";
import CodeEditor from "../../components/Solusek/CodeEditor";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import { qreq } from "../../shared/qrequest";
import { Pop } from "../../components/PopModal";
import APIProperties from "./components/APIProperties";
import APICom from "./components/APICom";

class APISpec extends APICom {
    constructor(props) {
        super(props);
        this.state = {
            query: {},
            response: {}
        };
    }


    async componentDidMount() {
        await super.componentDidMount();
        await this.loadAsync();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.params.ident !== prevProps.params.ident) {
            await this.loadAsync();
            this.rehash();
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    loadAsync = async () => {
        await this.fillItemAsync('/api/spec/item/' + this.props.params.ident, 'item');
        this.setState({ modifiedPath: null, response: null });
    }

    path = () => {
        if(this.state.modifiedPath)
            return this.state.modifiedPath;
        let proto = 'https://';
        if(this.state.currentClient?.hostname === 'localhost:8080')
            proto = 'http://';
        return (this.state.currentClient?.hostname ? proto + this.state.currentClient?.hostname : '') + '/' + this.state.item?.path;
    }


    performRequest = async (e) => {
        e?.preventDefault();
        if(this.path()?.indexOf('{id}') >= 0) {
            Pop.show(<L>Validation</L>, <L>Please replace <b>&#123;id&#125;</b> in the request path.</L>);
            return;
        }

        if(!this.state.currentClient) {
            Pop.show(<L>Validation</L>,<L>Please select Client in the top right of the screen.</L>);
            return;
        }
        if(!this.state.currentCreds) {
            Pop.show(<L>Validation</L>,<L>Please select Credentials in the top right of the screen.</L>);
            return;
        }
        if (!this.state.query.apiSecret) {
            this.setState({ showRequestSecret: true });
            return;
        }

        this.setState({ response: null });

        try {
            let j = {};
            let headers = {
                'Authorization': 'Basic ' + btoa(this.state.currentCreds.apiKey + ':' + this.state.query.apiSecret)
            };
            if (this.state.item.methodType === 'POST')
                j = await qreq.postAsync(this.path(), JSON.parse(this.state.item.requestBody), true, headers);
            else
                j = await qreq.getAsync(this.path(), true, headers);

            this.setState({ showRequestSecret: false, response: { body: JSON.stringify(j, null, 2) }, responseError: j.errorCode !== 0, responseSuccess: j.errorCode === 0 });

        }
        catch (e) {
            console.log(e);
            if(e.message && e.message.indexOf('Unexpected token') >= 0)
                this.setState({ response: { body: 'Can not display this data on this view.', responseError: false, responseSuccess: false } });
            else
                this.unkownErrorCallback();
            this.setState({ showRequestSecret: false });
        }
    }

    change = () => {
        this.setState({ query: { ...this.state.query } });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>{this.state.item?.name}</h1>
                <p>{this.state.item?.description}</p>
                <Card title="Request Header">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: '200px' }}>Authorization</td>
                                <td>
                                    Basic <span>
                                        <span className="text-primary">BASE64(<span className="text-success">"</span>
                                        </span>{this.state.currentCreds?.apiKey || 'APIKEY'}:<i className="text-muted">{this.state.query?.apiSecret || 'APISECRET'}</i><span className="text-primary">
                                            <span className="text-success">"</span>)</span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card>
                <Card title="Request">
                    <h5><L>Endpoint</L></h5>
                    <div className="input-group mb-3">
                        <div className={'input-group-text text-light ' + (this.state.item?.methodType === 'POST' ? 'bg-success' : 'bg-primary')}>
                            <strong>{this.state.item?.methodType}</strong>
                        </div>
                        <input type="text" className="form-control" value={this.path()} onChange={(e) => this.setState({ modifiedPath: e.target.value })} />
                        <div className="input-group-text">
                            <button type="button" className="btn btn-primary" onClick={this.performRequest}>
                                <L>TEST REQUEST</L>
                            </button>
                        </div>
                    </div>
                    <h5><L>Body</L></h5>
                    <div className="row mb-3">
                        {this.state.item?.requestBody && this.state.item?.methodType === 'POST' && <div className="col-md">
                            <CodeEditor
                                value={this.state.item.requestBody}
                                height="50vh"
                                onChange={(v) => this.setState({ item: {...this.state.item, requestBody: v }})}
                                hash={this.state.hash}
                                />
                        </div>}
                        <div className="col-md">
                            <FormInputV2
                                model={this.state.response}
                                name="body"
                                type="textarea"
                                style={{ height: '50vh', color: this.state.responseSuccess ? 'green' : this.state.responseError ? 'red' : '' }}
                                placeholder="Response..."
                                readOnly
                                />
                        </div>
                    </div>
                </Card>

                {this.state.item?.requestProperties && this.state.item.requestProperties.length > 0 && <Card title="Request Properties">
                    <APIProperties properties={this.state.item.requestProperties} />
                </Card>}

                {this.state.item?.responseProperties && this.state.item.responseProperties.length > 0 && <Card title="Response Properties">
                    <APIProperties properties={this.state.item.responseProperties} isResponse />
                </Card>}



                <Modal show={this.state.showRequestSecret} onHide={() => this.setState({ showRequestSecret: false })}>
                    <Modal.Header>
                        <Modal.Title><L>API Secret</L></Modal.Title>
                    </Modal.Header>
                    <form onSubmit={this.performRequest}>
                        <Modal.Body>
                            <FormInputV2 model={this.state.query} name="apiSecret" label="API Secret" required onChange={this.change} />
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <button type="submit" className="btn btn-success">
                                    <L>Submit</L>
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showRequestSecret: false })}>
                                    <L>Cancel</L>
                                </button>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>
            </div>
        );
    }
}

export default withParamsAndNavigate(APISpec);